import { notification } from 'antd';
import history from '@/utils/history';
import codeMessage from './codeMessage';

const errorHandler = (error) => {
  const { response } = error;

  if (response && response.status) {
    const message = response.data && response.data.message;

    const errorText = message || codeMessage[response.status];
    const { status } = response;
    notification.config({
      duration: 10,
    });
    notification.error({
      message: `Accès Non AUTORISÉ, ${status}`,
      description: errorText,
    });
    if (response.data && response.data.jwtExpired) {
      history.push('/logout');
    }
    return response.data;
  } else {
    notification.config({
      duration: 5,
    });
    notification.error({
      message: 'Pas de connexion Internet',
      description: 'Impossible de vous connecter au serveur, vérifiez votre réseau Internet',
    });
    return {
      success: false,
      result: null,
      message: 'Impossible de vous connecter au serveur, vérifiez votre réseau Internet',
    };
  }
};

export default errorHandler;
